var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCountry(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_82_924)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99695 14.661C11.6774 14.661 14.6611 11.6774 14.6611 7.99689C14.6611 4.31639 11.6774 1.33276 7.99695 1.33276C4.31645 1.33276 1.33282 4.31639 1.33282 7.99689C1.33282 11.6774 4.31645 14.661 7.99695 14.661Z",
    stroke: "#6A7282",
    strokeWidth: 1.33282,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.3313 7.99689C5.3313 5.51566 6.28576 3.12951 7.99695 1.33276C9.70814 3.12951 10.6626 5.51566 10.6626 7.99689C10.6626 10.4781 9.70814 12.8643 7.99695 14.661C6.28576 12.8643 5.3313 10.4781 5.3313 7.99689Z",
    stroke: "#6A7282",
    strokeWidth: 1.33282,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.33282 7.99707H14.6611",
    stroke: "#6A7282",
    strokeWidth: 1.33282,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_82_924"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.9939,
    height: 15.9939,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountry);
export default __webpack_public_path__ + "static/media/country.9c30b064de1a8838cbba38e71ff409a3.svg";
export { ForwardRef as ReactComponent };